'use strict';
define([], function () {
    return {
        templateUrl: 'app/components/access-components/st-review-box/st-review-box.html',
        bindings: {
            dialogMode: '<',
            category: '<',
            compactMode: '<',
            carouselMode: '<'
        },
        controller: ['$scope', '$interval', 'ReviewsService',
            function ($scope, $interval, ReviewsService) {
                var vm = $scope;
                var ctrl = this;
                var rotationPromise;

                ctrl.$onInit = function () {
                    selectReview();
                };

                ctrl.$onDestroy = function () {
                    stopRotation();
                };

                vm.$watch('$ctrl.category', selectReview);
                vm.selectReviewIndex = selectReviewIndex;

                function selectReview() {
                    var reviews = ReviewsService.getAll();
                    var category = vm.$ctrl.category;
                    var filteredReviews = category ? reviews.filter(function (review) {
                        return review.category.toLowerCase() === String(category).toLowerCase();
                    }) : reviews;

                    if (!filteredReviews.length) {
                        filteredReviews = reviews;
                    }

                    vm.reviews = filteredReviews;
                    vm.reviewIndex = Math.floor(Math.random() * filteredReviews.length);
                    vm.currentReview = filteredReviews[vm.reviewIndex];
                    startRotation();
                }

                function selectReviewIndex(index) {
                    if (!vm.reviews || !vm.reviews[index]) {
                        return;
                    }
                    vm.reviewIndex = index;
                    vm.currentReview = vm.reviews[index];
                    startRotation();
                }

                function startRotation() {
                    stopRotation();
                    if (!ctrl.carouselMode || !vm.reviews || vm.reviews.length < 2) {
                        return;
                    }
                    rotationPromise = $interval(function () {
                        vm.reviewIndex = (vm.reviewIndex + 1) % vm.reviews.length;
                        vm.currentReview = vm.reviews[vm.reviewIndex];
                    }, 5000);
                }

                function stopRotation() {
                    if (rotationPromise) {
                        $interval.cancel(rotationPromise);
                        rotationPromise = null;
                    }
                }
            }]
    };
});
